<template>
  <span class="step" :class="{ active: isActive }">{{ name }}</span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
.progress-arrow {
  position: relative;
  display: block;
  width: calc(25% - 15.5px);
  font-size: 0.75rem;
  text-align: center;
  line-height: 31px;
  @apply text-gray-62;
  background: #dde1ed;
  &::after {
    position: absolute;
    top: 0;
    right: -31px;
    content: '';
    display: block;
    width: 30px;
    height: 31px;
    border: 15.5px solid transparent;
    border-left: 15.5px solid #dde1ed;
  }
  &.progress-arrow.active {
    color: #fff;
    background: #344464;
    &::after {
      border-left-color: #344464;
    }
  }
}

.step {
  @apply relative block text-xs text-gray-62 text-center bg-gray-08 mr-4 leading-8;
  width: 165px;

  &::after {
    @apply absolute block top-0 -right-8 w-8 h-8;
    content: '';
    border: 16px solid transparent;
    border-left: 16px solid rgba(6, 16, 26, 0.08); // border-gray-08
  }
}

.step.active {
  @apply text-white;
  background: #102855; // navy

  &::after {
    border-left-color: #102855; // navy
  }
}
</style>
